/**
 * Keys must match values in `NOTIFICATION_SIGNAL_HEADER_EVENT_TYPE_TAXONOMY`
 * (`notificationSignalHeaderLabelItems.ts`) — English default labels as i18n keys.
 */
const translations = {
  en: {
    "Rating Pillar Rank Changed": "Rating Pillar Rank Changed",
    "Earnings Flash Ready": "Earnings Flash Ready",
    "Earnings Transcript Ready": "Earnings Transcript Ready",
    "Alpha Pick Published": "Alpha Pick Published",
    "Ta Signal Changed": "Ta Signal Changed",
  },
  zh: {
    "Rating Pillar Rank Changed": "排名变化",
    "Earnings Flash Ready": "财报发布",
    "Earnings Transcript Ready": "财报深度解读",
    "Alpha Pick Published": "Alpha Pick 发布",
    "Ta Signal Changed": "技术信号变化",
  },
  "zh-tw": {
    "Rating Pillar Rank Changed": "排名變化",
    "Earnings Flash Ready": "財報發布",
    "Earnings Transcript Ready": "財報深度解讀",
    "Alpha Pick Published": "Alpha Pick 發布",
    "Ta Signal Changed": "技術信號變化",
  },
  ko: {
    "Rating Pillar Rank Changed": "Rating Pillar Rank Changed",
    "Earnings Flash Ready": "Earnings Flash Ready",
    "Earnings Transcript Ready": "Earnings Transcript Ready",
    "Alpha Pick Published": "Alpha Pick Published",
    "Ta Signal Changed": "Ta Signal Changed",
  },
  vi: {
    "Rating Pillar Rank Changed": "Rating Pillar Rank Changed",
    "Earnings Flash Ready": "Earnings Flash Ready",
    "Earnings Transcript Ready": "Earnings Transcript Ready",
    "Alpha Pick Published": "Alpha Pick Published",
    "Ta Signal Changed": "Ta Signal Changed",
  },
  es: {
    "Rating Pillar Rank Changed": "Rating Pillar Rank Changed",
    "Earnings Flash Ready": "Earnings Flash Ready",
    "Earnings Transcript Ready": "Earnings Transcript Ready",
    "Alpha Pick Published": "Alpha Pick Published",
    "Ta Signal Changed": "Ta Signal Changed",
  },
  tr: {
    "Rating Pillar Rank Changed": "Rating Pillar Rank Changed",
    "Earnings Flash Ready": "Earnings Flash Ready",
    "Earnings Transcript Ready": "Earnings Transcript Ready",
    "Alpha Pick Published": "Alpha Pick Published",
    "Ta Signal Changed": "Ta Signal Changed",
  },
  fr: {
    "Rating Pillar Rank Changed": "Rating Pillar Rank Changed",
    "Earnings Flash Ready": "Earnings Flash Ready",
    "Earnings Transcript Ready": "Earnings Transcript Ready",
    "Alpha Pick Published": "Alpha Pick Published",
    "Ta Signal Changed": "Ta Signal Changed",
  },
  ja: {
    "Rating Pillar Rank Changed": "Rating Pillar Rank Changed",
    "Earnings Flash Ready": "Earnings Flash Ready",
    "Earnings Transcript Ready": "Earnings Transcript Ready",
    "Alpha Pick Published": "Alpha Pick Published",
    "Ta Signal Changed": "Ta Signal Changed",
  },
};

export default translations;
